import { createRoute, useNavigate } from "@tanstack/react-router";
import { Route as dashboardRoute } from "../dashboard";
import ProjectCreationView from "@/components/projects/ProjectCreationView";

type NewProjectSearch = {
  projectId?: string;
};

function NewProjectPage() {
  const navigate = useNavigate();
  const { projectId } = Route.useSearch();
  return (
    <ProjectCreationView
      onBack={() => navigate({ to: "/dashboard" })}
      projectId={projectId}
    />
  );
}

export const Route = createRoute({
  getParentRoute: () => dashboardRoute,
  path: "new-project",
  component: NewProjectPage,
  validateSearch: (search: Record<string, unknown>): NewProjectSearch => ({
    projectId: typeof search.projectId === "string" ? search.projectId : undefined,
  }),
});
